import React from 'react';
import { Fade } from 'react-slideshow-image';
import 'react-slideshow-image/dist/styles.css'
import s1 from "../../assets/s1.jpg";
import s2 from "../../assets/s2.jpg";
import s3 from "../../assets/s3.jpg";
import s4 from "../../assets/s4.jpg";
const fadeImages = [
  {
  url: s1
  },
  {
  url: s2
  },
  {
  url: s3
  },
  {
  url: s4
  }
];

const Slideshow = () => {
  return (
    <div className="left">
      <Fade duration={2000} canSwipe={false} arrows={false}>
        {fadeImages.map((fadeImage, index) => (
          <div className="each-fade" key={index} style={{backgroundImage: `url(${fadeImage.url})`}}>
          </div>
        ))}
      </Fade>
    </div>
  )
}

export default Slideshow;


// WEBPACK FOOTER //
// ./src/pages/login/Slideshow.tsx